import { KeyValueModel } from "model";
import { EnumModeloECF } from "model/enums/enum-modelo-ecf";

export const ModeloECFMock: KeyValueModel[] = [
    new KeyValueModel(EnumModeloECF.CFE_MAQUINA_REGISTRADORA, "Cupom Fiscal Emitido por Máquina Registradora"),
    new KeyValueModel(EnumModeloECF.CFPDV, "Cupom Fiscal PDV"),
    new KeyValueModel(EnumModeloECF.CF_ECF, "Cupom Fiscal (emitido por ECF)"),
];
